export default {
  GET_NODE_FIELD_VALUES: 'getNodeFieldValues',
  SAVE_FORM_VALUES: 'saveFormValues',
}